import { supabase } from '@/utils/supabase';

export type Metrics = {
  request_count: number;
  dentist_count: number;
  clinic_count: number;
  patient_count: number;
};

/**
 * Fetches metrics data from the database using the get_metrics RPC.
 * @returns The metrics data object.
 * @throws Will throw an error if the fetch fails or no data is returned.
 */
export const fetchMetrics = async (): Promise<Metrics> => {
  const { data, error } = await supabase.rpc('get_metrics');
  if (error || !data || data.length === 0) throw error;
  return data[0];
};
